import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { Observable, Subject } from "rxjs";

import { MatRadioChange } from "@angular/material/radio";

import { JSR310ConversionService } from "../../../../shared/jsr310-localdates/services/jsr310-conversion.service";
import { GroupementParcService } from '../../../structure/groupement-parc/services/groupement-parc.service';
import { OuvrageService } from '../../../structure/ouvrage/services/ouvrage.service';

import { LocalDate } from "../../../../shared/jsr310-localdates/types/local-date.type";

import { ParcTLR } from "../../../structure/parc/entities/parc-tlr.entity";
import { GroupementParc } from "../../../structure/groupement-parc/entities/groupement-parc.entity";
import { OuvrageTLR } from "../../../structure/ouvrage/entities/ouvrage-tlr.entity";
import { OuvrageDto } from "../../../structure/ouvrage/entities/ouvrage-dto.entity";

import { EtatPdp, PlanPreventionEntity } from "../../entities/plan-prevention.entity";
import { applicationConstants } from '../../../../app.constants';
import { SubjectRelay } from "../../../../shared/commands/subject-relay.class";

@Component({
    selector: 'info-generales',
    templateUrl: 'info-generales.html',
    styleUrls: ['info-generales.css']
})
export class InfoGeneralesComponent {
    private _mandatoryField: boolean = false;

	etatPdp: typeof EtatPdp = EtatPdp;
	
	planPreventionModel: PlanPreventionEntity = new PlanPreventionEntity();
    numeroPdp!: string;
    antenneId!: number | null;
    ouvragesIds: number[] = [];
    ouvrages: OuvrageTLR[] = [];
    fieldsDisabled: boolean = false;
    dureeDisabled: boolean = true;
    autre!: string;
    listeTypePdp = ['Général', 'Spécifique'];
    typePdp = 'Général';
    nombreIntervenants: number = 1;
    resetAntenneIdCommands = new Subject<number | null | undefined>();
    dateDebut!: number[] | null;
    dateFin!: number[] | null;
    duree: number = 36; // PDP général 36 mois en version 1++
    delai!: number;
    typeDuree: string = '(mois)';
    ouvrageSelectorClass: string = 'col-md-12 pdp-ouvrage-field-selector';

	// Memorisation de la technologie du parc actuel
	private parcEnergie: string | null = null;
	
	groupementParc!: GroupementParc | null | undefined;
    selectedParc!: ParcTLR | null | undefined;
	ouvrageNames: string = '';
	
	private infosGeneraleCommandsSubject = new SubjectRelay<PlanPreventionEntity>();
	@Input() set infosGeneraleCommands(obs: Observable<PlanPreventionEntity> | undefined) {
		this.infosGeneraleCommandsSubject.registerSource(obs);
	}
    
    constructor(
		@Inject(JSR310ConversionService) private conversionService: JSR310ConversionService,
		@Inject(OuvrageService) private ouvrageService: OuvrageService,
		@Inject(GroupementParcService) private groupementParcService: GroupementParcService ) {

		this.infosGeneraleCommandsSubject.subscribe(
			// lors de la reception d'une demande d'affichage
			(pdp: PlanPreventionEntity) => {
				console.log('demande edition infos generale pour le PDP: ', pdp.id);
				this.init(pdp);
			}
		);
	}
    
	init(pdp: PlanPreventionEntity) {
		
		this.groupementParc = null;
		this.selectedParc = null;
		this.planPreventionModel = pdp;

        if (localStorage['ngStorage-user']) {
            let userInfos: any = JSON.parse(localStorage['ngStorage-user'])
            this.antenneId = userInfos['idAntenne'];
        }
		
        if (pdp.id) {
			// on est en mode update ou duplicate
			if (this.planPreventionModel.mode === 'duplicate') {
				this.planPreventionModel.versionTechnique = applicationConstants.currentPdpVersion;
			} 
			
			this.numeroPdp = this.planPreventionModel.numeroPdp;
			this.autre = this.planPreventionModel.autre;
			
			// dates de debut et de fin
			this.duree = this.planPreventionModel.duree ? this.planPreventionModel.duree : this.duree;
			this.dateDebut = this.planPreventionModel.debutValidite;
			this.dateFin = this.planPreventionModel.finValidite;
			
			// nombre intervenants
			this.nombreIntervenants = this.planPreventionModel.nombreIntervenants;
			
			// type PDP
			this.typePdp = Number(this.planPreventionModel.typePdp) === 0 ? 'Général' : 'Spécifique';
	        if (this.typePdp === 'Général') {
	            this.duree = this.planPreventionModel.versionTechnique === 1 ? 12 : 36; // PDP annuel en version 1, général en version 1++
	            if (this.planPreventionModel.mode === 'duplicate' && this.planPreventionModel.versionTechnique === 1) {
					this.duree = 36;
				}
	            this.dureeDisabled = true;
	            this.onDateDebutChange(this.dateDebut)
	        } else {
	            this.dureeDisabled = false;
                this.typeDuree = '(jours)';
	        }
			
			// parc, antenne, ouvrages
            if (this.planPreventionModel.mode !== 'duplicate') {
				
				this.ouvrageNames = '';
				this.ouvrages = [];
				this.planPreventionModel.ouvrages = [];
				this.planPreventionModel.idOuvrages.split(',').forEach( oId => {
					this.ouvrageService.getOuvrageTLRById(Number(oId)).subscribe(
						(ouvrage: OuvrageTLR) => {
							this.ouvrageNames = this.ouvrageNames + (this.ouvrageNames.length ? ', ' : '') + ouvrage.nom;
							this.ouvrages.push(ouvrage);
							let ouvrageDto = new OuvrageDto();
							ouvrageDto.id = ouvrage.id;
							this.planPreventionModel.ouvrages.push(ouvrageDto);
						} 
					);
				} );
				
            } else {
				// en mode duplicate le parc n'est pas recopié
				this.planPreventionModel.parcIds = [];
			}
			
			// signaler les changements
        	this.modelChange.emit(this.planPreventionModel);
		} else {
			// on est en mode create
			this.parcEnergie = null;
			this.numeroPdp = '';
			this.dateDebut = null;
			this.dateFin = null;
			this.planPreventionModel.typePdp = 0;
			this.typePdp = 'Général'; // par défaut le type PDP est "Général"
			this.duree = 36;
			this.nombreIntervenants = 1;
			this.ouvrageIds = [];
        	this.ouvrageIdsChange.emit([]);
			this.planPreventionModel.etat = EtatPdp.BROUILLON;
			this.planPreventionModel.versionTechnique = applicationConstants.currentPdpVersion;
		}
	}
	
	@Input() set mandatoryField(value: boolean) {
	    this._mandatoryField = value;
	    this.ouvrageSelectorClass = value ?  'col-md-12 pdp-ouvrage-field-selector' + ' highlightable' : 'col-md-12 pdp-ouvrage-field-selector';
	}
	get mandatoryField(): boolean {
	    return this._mandatoryField;
	}
    
	@Input() ouvrageIds: number[] = [];
    @Output() ouvrageIdsChange = new EventEmitter<number[]>();

	@Output() antenneChange = new EventEmitter<number>();

	@Output() energieChange = new EventEmitter<string | null>();

    @Output() modelChange = new EventEmitter<PlanPreventionEntity>();

    onParcSelected(_parcs: ParcTLR[] | undefined) {
		if (_parcs != undefined) {
			if (this.planPreventionModel.mode === 'update') {
		        this.ouvrageIds = [];
		        this.ouvrageIdsChange.emit([]);
			}
			// on considre le premier élt de la liste car l'info est redondante pour tour tous les parcs
	        this.planPreventionModel.parcIds = _parcs.map( $ => $.id );
	        if (_parcs.length) {
				let parc= _parcs[0];
				let newEnergie: string | null = null;
		        if (parc) {
					this.planPreventionModel.antenneId = parc.antenneId;
					this.planPreventionModel.referentParcId = parc.responsableId as number;
					newEnergie = parc.energie;	
					if (this.antenneId != parc.antenneId) {
						this.antenneChange.next(parc.antenneId);
			            this.resetAntenneIdCommands.next(parc.antenneId);
			        }
				}
				if (newEnergie !== this.parcEnergie) {
					this.parcEnergie = newEnergie;
					this.energieChange.emit(newEnergie);
				}
				if (_parcs.length === 1 || this.planPreventionModel.mode === 'update') {
					// premier parc choisi: on vérifie si ce parc est dans un groupements
					this.groupementParcService.findbyParcId(parc.id).subscribe(
						(groupement: GroupementParc | undefined) => {
							if (groupement) {
								this.groupementParc = groupement;
								this.selectedParc = null;
							} else {
								this.selectedParc = parc;
								this.groupementParc = null;
							}
						}
					);
				}
			}
	        this.modelChange.emit(this.planPreventionModel);
		}
    }

    onSelectedOuvragesChange(ouvrages: OuvrageTLR[], propagateChanges: boolean) {
        this.ouvrages = ouvrages;
		this.planPreventionModel.ouvrages = [];
		this.ouvrages.forEach( $ => {
			let ouvrage = new OuvrageDto();
			ouvrage.id = $.id;
			this.planPreventionModel.classeOuvrageIds.push($.classeOuvrage);
			this.planPreventionModel.ouvrages.push(ouvrage);
        });
		if (propagateChanges) {
	        this.modelChange.emit(this.planPreventionModel);
		}
    }

    onDateDebutChange(_date: number[] | null) {
        if(this.typePdp === 'Général') {
            // PDP annuel en version 1, général en version 1++
            this.duree = this.planPreventionModel.versionTechnique > 1 || this.planPreventionModel.mode === 'duplicate' ? 36 : 12;
        }
        if (this.dateDebut) {
            let dateFin = this.conversionService.fromMandatoryLocalDate(
				[ this.dateDebut[0], this.dateDebut[1], this.dateDebut[2] ] as LocalDate
			);
            this.setDateFinWithDuree(dateFin);
            this.dateFin = this.conversionService.toMandatoryLocalDate(dateFin);
            this.planPreventionModel.finValidite = this.dateFin;
        }
		this.planPreventionModel.debutValidite = this.dateDebut != null ? this.dateDebut : [];
        this.modelChange.emit(this.planPreventionModel);
    }

    onDateFinChange(_date: number[] | null) {
        if (this.typePdp !== 'Général' && this.dateDebut && this.dateFin) {
            let dateDebut = this.conversionService.fromMandatoryLocalDate(
				[ this.dateDebut[0], this.dateDebut[1], this.dateDebut[2] ] as LocalDate
			);
            let dateFin = this.conversionService.fromMandatoryLocalDate(
				[ this.dateFin[0], this.dateFin[1], this.dateFin[2] ] as LocalDate
			);
            let timeDifference = dateFin.getTime() - dateDebut.getTime();
            this.duree = Math.round(timeDifference / (1000 * 3600 * 24)) + 1;
        }
        this.planPreventionModel.duree = this.duree != null ? this.duree : 1;
		this.planPreventionModel.finValidite = this.dateFin != null ? this.dateFin : [];
        this.modelChange.emit(this.planPreventionModel);
    }

    private setDateFinWithDuree(dateFin: Date) {
        if (this.typePdp === 'Général') {
            dateFin.setMonth(this.duree + dateFin.getMonth());
            dateFin.setDate(dateFin.getDate() - 1);
        } else {
            dateFin.setDate(this.duree - 1 + dateFin.getDate());
        }
    }

    calculateDateFin() {
        if (this.dateDebut && this.duree) {
            let dateFin = this.conversionService.fromMandatoryLocalDate(
				[ this.dateDebut[0], this.dateDebut[1], this.dateDebut[2] ] as LocalDate
			);
            this.setDateFinWithDuree(dateFin);
            this.dateFin = this.conversionService.toMandatoryLocalDate(dateFin);
        }
        //we use 0-11 for months for this.dateFin for calculation purpose but java doesn't like it
        if (this.dateFin != null) {
            if(this.dateFin[1] == 0) {
                this.dateFin[1] = 12;
                this.dateFin[0] -= 1;
            }
            this.planPreventionModel.finValidite = this.dateFin;
        } else {
            this.planPreventionModel.finValidite = [];
        }
        this.planPreventionModel.duree = this.duree != null ? this.duree : 1;
        this.modelChange.emit(this.planPreventionModel);
    }
    
    typePdpChange(event: MatRadioChange) {
        if (event.value === 'Général') {
			// PDP annuel en version 1, général en version 1++
            this.duree = this.planPreventionModel.versionTechnique > 1 ? 36 : 12;
            if (this.planPreventionModel.mode === 'duplicate' && this.planPreventionModel.versionTechnique === 1) {
				this.duree = 36;
			}
            this.dureeDisabled = true;
            this.typeDuree = '(mois)';
            this.onDateDebutChange(this.dateDebut)
        } else {
            this.dureeDisabled = false;
            this.duree = 1;
            this.typeDuree = '(jours)';
            this.dateFin = null;
        }
        this.calculateDateFin();
        this.planPreventionModel.typePdp = this.typePdp === 'Général' ? 0 : 1;
        this.modelChange.emit(this.planPreventionModel);
    }
    
    onNumeroPdpChange(_event: any | undefined) {
		this.planPreventionModel.numeroPdp = this.numeroPdp;
        this.modelChange.emit(this.planPreventionModel);
	}
	
	onAutreChange(_event: any | undefined) {
		this.planPreventionModel.autre = this.autre;
        this.modelChange.emit(this.planPreventionModel);
	}
	
	onNbIntervenantsChange(_event: any | undefined) {
		this.planPreventionModel.nombreIntervenants = this.nombreIntervenants != null ? this.nombreIntervenants : 0;
        this.modelChange.emit(this.planPreventionModel);
	}
	
	onDescriptionChange(_event: any | undefined) {
        this.modelChange.emit(this.planPreventionModel);
	}

	shouldDisableMajDateDebut() {
		if (this.planPreventionModel.typePdp === 0) {
			return this.planPreventionModel.etat !== EtatPdp.BROUILLON && this.planPreventionModel.etat !== EtatPdp.A_FAIRE_SIGNER;
		}
		return false;
	}

	shouldDisableMajDateFin() {
		if (this.planPreventionModel.typePdp === 0) {
			return true;
		} else if (this.planPreventionModel.typePdp === 1) {
			return this.planPreventionModel.etat !== EtatPdp.BROUILLON && this.planPreventionModel.etat !== EtatPdp.A_FAIRE_SIGNER;
		}
		return false;
	}
}